import {action} from "mobx";
import supplierService from "../services/supplierService";
import appStore from "./appStore";

class SupplierStore {
    @action supplierList = async (params) => {
        try {
            const response = await supplierService.supplierList(params);
            return response.data;
        } catch (error) {
            console.error("Error fetching supplier list:", error);
            return [];
        }
    };

    @action supplierInfo = async (params) => {
        try {
            const response = await supplierService.supplierInfo(params);
            return response.data?.data;
        } catch (error) {
            console.error("Error fetching supplier list:", error);
            return [];
        }
    };

    @action updateSupplier = async (params) => {
        try {
            const response = await supplierService.updateSupplier(params);
            return response.data;
        } catch (error) {
            console.error("Error fetching supplier list:", error);
            return [];
        }
    };

    @action createSupplier = async (params) => {
        try {
            const response = await supplierService.createSupplier(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            console.error("Error fetching supplier list:", error);
            return false;
        }
    };

    @action deleteSupplier = async (params) => {
        try {
            const response = await supplierService.deleteSupplier(params);
            return response.data;
        } catch (error) {
            console.error("Error fetching supplier list:", error);
            return [];
        }
    };

    @action patchSupplier = async (params) => {
        try {
            const response = await supplierService.patchSupplier(params);
            return response.data;
        } catch (error) {
            console.error("Error fetching supplier list:", error);
            return [];
        }
    };

    @action updateSupplierSecret = async (params) => {
        try {
            const response = await supplierService.updateSupplierSecret(params);
            return response.data;
        } catch (error) {
            console.error("Error fetching supplier list:", error);
            return [];
        }
    };
}

export default new SupplierStore();
